import {FC, useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
  activateGhlIntegration,
  deactivateGhlIntegration,
  fetchActiveIntegrationApp,
  getActivateIntegrationByUser,
  getIntegrationRefetchDataStatus,
  resetSelectedIntegrationData,
} from '../IntegrationSlice/IntegrationSlice'
import {Form, Button, Accordion, Card, Row, Col} from 'react-bootstrap'
import {isLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {ExternalProvider} from '../IntegrationSlice/Types'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'
import {Link} from 'react-router-dom'
import {toast} from 'react-toastify'
import {useLazyGetSendersQuery} from '../../../../../services/cellcast.v2'
import Select from 'react-select'
import {
  useActivateIntegrationAppMutation,
  useDeactivateIntegrationAppMutation,
  useUpdateGhlSenderMutation,
  useUpdateIntegrationAppDataMutation,
} from '../../../../../services/cellcast'
import {SenderCamp} from '../../../../../services/cellcast.type'
import {findIndex} from 'lodash'
import {
  fetchAsyncUserDetails,
  getAllUserDetails,
} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {
  getApikeyListData,
  getApiKeysListOfuser,
} from '../../accounts/ApiKeys/ApikeysSlices/ApiKeysSlices'

interface Stirpe {
  selectedExternalProvider: ExternalProvider
  userData: any
}

const API_URL = ENV().REACT_APP_API_URL

const Stripe: FC<Stirpe> = ({selectedExternalProvider, userData}) => {
  let userId = ''
  if (userData && userData.user) {
    if (userData.user._id !== userData.user.ownerId && !userData.user.subClientAccountId) {
      userId = userData.user.ownerId
    } else {
      userId = userData.user._id
    }
  }
  const apikeyListData = useSelector(getApikeyListData)

  const selectedActiveIntegration = useSelector(
    getActivateIntegrationByUser(userId, selectedExternalProvider._id)
  )
  const token =
    apikeyListData?.length > 0 ? apikeyListData?.find((el: any) => el.name === 'stripe') : null

  const [activateIntegration] = useActivateIntegrationAppMutation()
  const [deactivateIntegration] = useDeactivateIntegrationAppMutation()

  const [updateIntegrationData, {isLoading: updateIntegrationDataLoading}] =
    useUpdateIntegrationAppDataMutation()
  const refetch = useSelector(getIntegrationRefetchDataStatus)
  const globalLoading = useSelector(isLoading)

  const dispatch = useDispatch()

  const [value, setValue] = useState<{eventType: string; message: string}[]>([])

  // load data when first load
  useEffect(() => {
    if (selectedExternalProvider._id) {
      dispatch(resetSelectedIntegrationData)
      dispatch(fetchActiveIntegrationApp())
    }
  }, [selectedExternalProvider])


  useEffect(() => {
    dispatch(getApiKeysListOfuser())
  }, [])


  useEffect(() => {
    if (selectedActiveIntegration && selectedActiveIntegration.data) {
      if (selectedActiveIntegration.data?.stripe) {
        setValue(selectedActiveIntegration.data?.stripe)
      }
    }
  }, [selectedActiveIntegration])

  useEffect(() => {
    if (refetch) {
      dispatch(fetchActiveIntegrationApp())
    }
  }, [refetch])

  // handle delete
  const [isOpenDeactivateConfirmation, setIsOpenDeactivateConfirmation] = useState(false)
  const [isDeleteConfirm, setIsDeleteConfirm] = useState(false)

  const onClickDeactivateHandler = () => {
    setIsOpenDeactivateConfirmation(true)
  }

  const onClickActivateHandler = () => {
    activateIntegration({
      integrationProviderName: 'Stripe',
    })
      .unwrap()
      .then((res) => {
        console.log(res, 'here res')
        toast.success(res?.message)
        dispatch(fetchActiveIntegrationApp())
        dispatch(fetchAsyncUserDetails())
        dispatch(getApiKeysListOfuser())
      })
  }

  const onUpdateData = () => {
    updateIntegrationData({data: value, integrationProviderName: 'Stripe'})
      .unwrap()
      .then((res) => {
        toast.success(res?.data?.message)
        dispatch(fetchActiveIntegrationApp())
        dispatch(getApiKeysListOfuser())
      })
  }

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenDeactivateConfirmation}
        handleClose={() => setIsOpenDeactivateConfirmation(false)}
        Message={'Are you sure, you want to deactivate integration ?'}
        confirm={() => setIsDeleteConfirm(true)}
        confirmBtnTitle='Yes, deactivate'
      />
    ),
    [isOpenDeactivateConfirmation]
  )

  useEffect(() => {
    if (isDeleteConfirm === true) {
      deactivateIntegration({
        integrationProviderName: 'Stripe',
      })
        .unwrap()
        .then((res) => {
          setIsDeleteConfirm(false)
          setIsOpenDeactivateConfirmation(false)
          dispatch(fetchActiveIntegrationApp())
          dispatch(fetchAsyncUserDetails())
          toast.success(res?.message)
        })
    }
  }, [isDeleteConfirm])

  return (
    <div className='card p-7 pb-lg-4 p-lg-10'>
      {confirmation}
      <h1>Detail Integration</h1>
      <div className='row'>
        <div className='card-body pt-9 pb-0'>
          <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
            <div className='me-7 mb-4'>
              <div
                className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'
                style={{
                  backgroundColor: '#f5f8fa',
                  borderColor: '#f5f8fa',
                  borderRadius: 5,
                  paddingLeft: 5,
                  paddingRight: 5,
                  borderWidth: 1,
                }}
              >
                {selectedExternalProvider?.image == '' || selectedExternalProvider == undefined ? (
                  <span
                    className='squere1'
                    style={{
                      width: '100px',
                      height: '100px',
                    }}
                  >{`${
                    selectedExternalProvider?.name !== undefined &&
                    selectedExternalProvider?.name !== ''
                      ? selectedExternalProvider?.name.split('')?.[0]?.toUpperCase() ?? 'C'
                      : 'EP'
                  }`}</span>
                ) : (
                  <img src={selectedExternalProvider.image} alt='stripe' />
                )}
                <div
                  className={`position-absolute translate-middle bottom-0 start-100 mb-6 rounded-circle border border-4 border-white h-20px w-20px ${
                    selectedActiveIntegration ? ' bg-success ' : 'bg-danger'
                  }`}
                ></div>
              </div>
            </div>
            <div className='flex-grow-1'>
              <span className='text-gray-800 fs-2 fw-bolder me-1 mb-10'>
                {selectedExternalProvider?.name ?? 'Undefined'}
              </span>
              {selectedActiveIntegration ? (
                <div className='mt-5'>
                  <Form.Group className='mb-10'>
                    <Form.Label>Cellcast Api Key Label</Form.Label>
                    <Form.Control
                      type='text'
                      disabled
                      value={selectedActiveIntegration?.internalApiKeyName}
                    />

                    <Form.Group className='mt-10'>
                      <Form.Label>Stripe Webhook URL</Form.Label>
                      <Form.Control
                        as='textarea'
                        rows={4}
                        disabled
                        value={`${API_URL}webhook/stripe-notification?token=${token?.token}` || ''}
                      />
                    </Form.Group>

                    <div>
                      <span className='text-muted'>Visit </span>
                      <Link to='/accounts/api-keys'>
                        <b>api page</b>
                      </Link>
                      <span className='text-muted'> for more detail </span>
                    </div>
                  </Form.Group>

                  {!globalLoading &&
                    ['invoice.payment_failed'].map((it) => (
                      <>
                        <Form.Group className='mb-10'>
                          <Form.Label>Stripe Event Type</Form.Label>
                          <Select
                            isSearchable={false}
                            defaultValue={{
                              label: value.find((v) => v.eventType === it)?.eventType,
                              value: value.find((v) => v.eventType === it)?.eventType,
                            }}
                            onChange={(e) => {
                              const item = {eventType: e?.value, message: ''}
                              setValue((prevValue: any) => {
                                const index = findIndex(prevValue, {eventType: it})

                                if (index !== -1) {
                                  // Modify existing item
                                  return prevValue.map((v: any, i: number) =>
                                    i === index ? item : v
                                  )
                                } else {
                                  // Add new item
                                  return [...prevValue, item]
                                }
                              })
                            }}
                            options={[
                              {value: 'invoice.payment_failed', label: 'invoice.payment_failed'},
                            ]}
                            name='message'
                            className={`common-select`}
                            placeholder='Stripe Event Type'
                          />
                        </Form.Group>
                        <Form.Group className='mb-10' key={it}>
                          <Form.Label>Message Template</Form.Label>
                          <Row>
                            <Col sm='6'>
                              <Form.Control
                                as='textarea'
                                rows={3}
                                defaultValue={value?.find((v) => v.eventType === it)?.message}
                                placeholder='Hi {{firstName}}, Your invoice of $ {{invoice}} failed due to insufficient funds. To pay now, check your emails or click here: {{stripHostedUrl}} Thanks!'
                                onChange={(e) => {
                                  const item = {eventType: it, message: e.target.value}
                                  setValue((prevValue) => {
                                    const index = findIndex(prevValue, {eventType: it})

                                    if (index !== -1) {
                                      // Modify existing item
                                      return prevValue.map((v, i) => (i === index ? item : v))
                                    } else {
                                      // Add new item
                                      return [...prevValue, item]
                                    }
                                  })
                                }}
                              />
                            </Col>
                            <Col sm='4'>
                              <Button variant='info' type='submit' size='sm' onClick={onUpdateData}>
                                {updateIntegrationDataLoading ? (
                                  <span className='spinner-border spinner-border-xl align-middle ms-2'></span>
                                ) : (
                                  'Configure'
                                )}
                              </Button>
                            </Col>
                          </Row>
                        </Form.Group>
                      </>
                    ))}
                  <Accordion className='mb-10'>
                    <Accordion.Item eventKey='0'>
                      <Accordion.Header>Integration Step</Accordion.Header>
                      <Accordion.Body>
                        <div className='row mb-10'>
                          <div className='mb-5' style={{fontSize: 14}}>
                            1. Stripe <i className='bi bi-arrow-right-short'></i> Copy generated
                            webhook url
                          </div>
                          <img
                            src='https://cellcast-profile-image.s3.ap-southeast-2.amazonaws.com/assets/stripe/Screenshot_2.png'
                            width={'75%'}
                            alt='nav-click'
                          />
                        </div>
                        <div className='row mb-10'>
                          <div className='mb-5' style={{fontSize: 14}}>
                            2. Go to{' '}
                            <a href='https://dashboard.stripe.com/webhooks'>
                              {' '}
                              https://dashboard.stripe.com/webhooks
                            </a>
                          </div>
                          <img
                            src='https://cellcast-profile-image.s3.ap-southeast-2.amazonaws.com/assets/stripe/Screenshot_3.png'
                            width={'75%'}
                            alt='nav-click'
                          />
                        </div>
                        <div className='row mb-10'>
                          <div className='mb-5' style={{fontSize: 14}}>
                            3. Click Add endpoints button
                          </div>
                          <img
                            src='https://cellcast-profile-image.s3.ap-southeast-2.amazonaws.com/assets/stripe/Screenshot_3.png'
                            width={'75%'}
                            alt='nav-click'
                          />
                        </div>
                        <div className='row mb-10'>
                          <div className='mb-5' style={{fontSize: 14}}>
                            4. Copy generated webhook url to endpoint URL field
                          </div>
                          <img
                            src='https://cellcast-profile-image.s3.ap-southeast-2.amazonaws.com/assets/stripe/Screenshot_5.png'
                            width={'75%'}
                            alt='nav-click'
                          />
                        </div>
                        <div className='row mb-10'>
                          <div className='mb-5' style={{fontSize: 14}}>
                            5. Select event type you want to integrate eg: invoice.payment_failed
                          </div>
                          <img
                            src='https://cellcast-profile-image.s3.ap-southeast-2.amazonaws.com/assets/stripe/Screenshot_5.png'
                            width={'75%'}
                            alt='nav-click'
                          />
                        </div>
                        <div className='row mb-10'>
                          <div className='mb-5' style={{fontSize: 14}}>
                            6. Click Add Endpoint
                          </div>
                          <img
                            src='https://cellcast-profile-image.s3.ap-southeast-2.amazonaws.com/assets/stripe/Screenshot_6.png'
                            width={'75%'}
                            alt='nav-click'
                          />
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                  <Button
                    variant='danger'
                    type='submit'
                    disabled={globalLoading}
                    onClick={() => onClickDeactivateHandler()}
                  >
                    {globalLoading ? (
                      <span className='spinner-border spinner-border-xl align-middle ms-2'></span>
                    ) : (
                      'Deactivate'
                    )}
                  </Button>
                </div>
              ) : (
                <div className='mt-20'>
                  <Button variant='primary' type='button' onClick={() => onClickActivateHandler()}>
                    {globalLoading ? (
                      <span className='spinner-border spinner-border-xl align-middle ms-2'></span>
                    ) : (
                      'Activate'
                    )}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {Stripe}
